/* eslint-disable import/prefer-default-export */
export const getFeedback =
  (categoryId: string, questionId: string) =>
  ({ feedback }: FeedbackState) => {
    const { categories } = feedback;
    const category = categories.find((category) => category.id === categoryId);
    const questions = category?.questions || [];

    return questions.find((question) => question.id === questionId);
  };
